import { cn } from '@/code/lib/utils/cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-xl bg-surface-container-high',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
